import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { FeltonDiscovery } from './felton/FeltonDiscovery';
import { FeltonChannels } from './felton/FeltonChannels';
import { FeltonChannelsLegacy } from './felton/FeltonChannelsLegacy';
import { FeltonSegments } from './felton/FeltonSegments';
import { FeltonCompare } from './felton/FeltonCompare';
import { FeltonOverlap } from './felton/FeltonOverlap';
import { FeltonFunnel } from './felton/FeltonFunnel';
import { FeltonContentUniverse } from './felton/FeltonContentUniverse';
import ProfilePage from '@/pages/Profile';
import SettingsPage from '@/pages/Settings';

const ChannelsPage = import.meta.env.VITE_SHOW_PROD === 'true' ? FeltonChannels : FeltonChannelsLegacy;

export const V11Routes: React.FC = () => {
  return (
    <Routes>
      {/* Default redirect to Discovery */}
      <Route index element={<Navigate to="/v11/discovery" replace />} />

      {/* V11 Module Routes */}
      <Route path="discovery" element={<FeltonDiscovery />} />
      <Route path="channels" element={<ChannelsPage />} />
      <Route path="funnel" element={<FeltonFunnel />} />
      <Route path="funnel/explore" element={<FeltonContentUniverse />} />
      <Route path="audience" element={<FeltonSegments />} />
      <Route path="compare" element={<FeltonCompare />} />
      <Route path="overlap" element={<FeltonOverlap />} />

      {/* User Management Routes */}
      <Route path="profile" element={<ProfilePage />} />
      <Route path="settings" element={<SettingsPage />} />

      {/* Legacy redirects */}
      <Route path="felton/explore" element={<Navigate to="/v11/discovery" replace />} />
      <Route path="felton/segments" element={<Navigate to="/v11/audience" replace />} />
      <Route path="felton/compare" element={<Navigate to="/v11/compare" replace />} />
      <Route path="felton/overlap" element={<Navigate to="/v11/overlap" replace />} />

      {/* Catch-all redirect */}
      <Route path="*" element={<Navigate to="/v11/discovery" replace />} />
    </Routes>
  );
};
